import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type PullzoneNotFoundForZoneIdErrorOptions = ObjectId;

export class PullzoneNotFoundForZoneIdError extends FleekError<PullzoneNotFoundForZoneIdErrorOptions> {
  public name = 'PullzoneNotFoundForZoneIdError';

  toString = () => {
    return `The pullzone is not found for zone id: ${this.data.id}`;
  };
}
